import { render, staticRenderFns } from "./LabelField.vue?vue&type=template&id=db1b219e&scoped=true"
import script from "./LabelField.vue?vue&type=script&lang=js"
export * from "./LabelField.vue?vue&type=script&lang=js"
import style0 from "./LabelField.vue?vue&type=style&index=0&id=db1b219e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@7.0.0-bridge.0_@babel+core@7.28._1eb1b9dda9fe6d233009820956254809/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1b219e",
  null
  
)

export default component.exports